export default "__VITE_ASSET__BmegMQhK__"